<template>
  <div class="top-of-box-bookmark">
    <b>
      Rapports
    </b>
  </div>
  <div class="big-blue-box">
    <div class="row">
      <div class="col">
        <BoiteBleu titre-de-la-boite="Dossier" :liste-de-liens="dossier" :solobox="false"/>
      </div>
      <div class="col">
        <div v-for="liens of autresBoites" :key="liens.titre">
          <BoiteBleu :titre-de-la-boite="liens.titre" :liste-de-liens="liens.liens" :solobox="true"/>
        </div>
      </div>
    </div>
  </div>
  <div class="col">
    <Button label="Fermer" v-on:click="fermer"/>
  </div>
</template>

<script>
import BoiteBleu from "@/components/rapports/dashboard/BoiteBleu.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "TousRapports",
  components: {BoiteBleu},
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil'
    })
  },
  methods: {
    pushActionToList(information, list) {
      var section = list.find(element => element.titre == information["section"])
      var url = process.env.VUE_APP_RAPPORTS_FICHIER_URL + information["url"];
      if (section !== undefined) {
        section["liens"].push({
          "titre": information["description"],
          "lien": url
        });
      } else {
        list.push({
          titre: information["section"], liens: [{
            "titre": information["description"],
            "lien": url
          }]
        })
      }
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.menu();
    }
  },
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store
        .dispatch('rapports/obtenirActionDecisionsRapportAction')
        .then((res) => {
          for (const information of res["data"]["liste"]) {
            if (information["isInDossier"]) {
              this.pushActionToList(information, this.dossier)
            } else {
              this.pushActionToList(information, this.autresBoites)
            }
          }
        });
  }, data() {
    return {
      dossier: [],
      autresBoites: []
    }
  }
}
</script>